module.exports = __webpack_public_path__ + "img/SGQR.661e8b93.jpg";